'use strict';
var validation = require('./validation');

module.exports = {

    typing: function typing(obj) {

        var self = this;

        if (obj.value.length > 2) {
            obj.isopen = true;
            obj.search = self.filterResult(obj.allvalues, obj.value);
        }

        if (obj.value.length === 0) {
            obj.isopen = false;
            obj.search = obj.allvalues;
        }
    },

    arrowUp: function arrowUp(obj) {
        if (obj.arrowcounter > 0) {
            obj.arrowcounter = obj.arrowcounter - 1;
        }
    },

    arrowDown: function arrowDown(obj) {
        if (obj.arrowcounter < obj.search.length) {
            obj.arrowcounter = obj.arrowcounter + 1;
        }
    },

    tab: function tab(e, obj) {

        if (obj.isopen) {

            

            if (obj.arrowcounter === -1 && !validation.arrayHasValue(obj.search, obj.value)) {
                e.preventDefault();

            } else if (obj.arrowcounter === -1 && validation.arrayHasValue(obj.search, obj.value)) {
                obj.isopen = false;
                obj.search = obj.allvalues; //reset search to all values
            } else {
                obj.value = obj.search[obj.arrowcounter];
                obj.isopen = false;
                obj.search = obj.allvalues; //reset search to all values
            }

            //reset arrow counter
            obj.arrowcounter = -1;
            
        }
    },

    enter: function enter(e, obj) {
        e.preventDefault();
        obj.value = obj.search[obj.arrowcounter];
        obj.isopen = false;

        //reset arrow counter and search result set
        obj.arrowcounter = -1;
        obj.search = obj.allvalues;
    },

    //return a list of items that contains user input
    filterResult: function filterResult(array, value) {
        return array.filter(function (el) {
            return el.toLowerCase().lastIndexOf(value.toLowerCase(), 0) === 0;
        });
    }
}